import {defineRecipe} from '@chakra-ui/react3'

const chakraLinkRecipe = defineRecipe({
    // prevents chakra2 focus indicator from applying
    className: 'chakra-link',
    base: {
        display: 'inline-flex',
        alignItems: 'center',
        outline: 'none',
        gap: '1.5',
        cursor: 'pointer',
        borderRadius: 'l1',
        focusRing: 'outside'
    },

    variants: {
        variant: {
            underline: {
                color: 'colorPalette.fg',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                textDecorationColor: 'currentColor/20'
            },
            plain: {
                color: 'colorPalette.fg',
                _hover: {
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px',
                    textDecorationColor: 'currentColor/20'
                }
            }
        }
    },

    defaultVariants: {
        variant: 'plain'
    }
})

export const linkRecipe = defineRecipe({
    ...chakraLinkRecipe,
    className: 'leap-link',
    base: {
        ...chakraLinkRecipe.base,
        display: 'inline-flex',
        alignItems: 'center',
        outline: 'none',
        cursor: 'pointer',
        borderRadius: 'none',
        focusRing: null,
        // for having the border only under the text and not under the icons
        '& span': {
            borderBottomWidth: '1px'
        },
        _hover: {
            textDecoration: 'none'
        },
        // focus state has 2px vertical and 4px horizontal padding. To avoid layout shift the focus uses outline,
        // but as we can't apply different spacing across axes we add the 2px horizontal padding to the base style
        // and have the outline offset of 1px (0 is actually 1st pixel outside the element) to get the expected 4px horizontal and 2px vertical
        paddingBlock: '0',
        marginInline: 'spacing-2',
        _focusVisible: {
            marginInline: '0',
            paddingInline: 'spacing-2',
            borderBottomColor: 'transparent',
            _hover: {
                borderBottomColor: 'transparent'
            },
            borderRadius: 's',
            outline: '1px solid',
            outlineOffset: '1px'
        }
    },
    variants: {
        variant: {
            primary: {
                color: 'text.brand-default',
                _hover: {
                    borderBottomColor: 'border.brand'
                },
                _focusVisible: {
                    outlineColor: 'border.brand'
                }
            },
            secondary: {
                color: 'text.primary',
                _hover: {
                    borderBottomColor: 'border.strong'
                },
                _focusVisible: {
                    outlineColor: 'border.strong'
                }
            }
        },
        underline: {
            false: {
                borderBottomColor: 'transparent'
            }
        },
        size: {
            default: {
                textStyle: 'body.medium',
                gap: 'spacing-8',
                _icon: {
                    width: '5',
                    height: '5'
                }
            },
            small: {
                textStyle: 'body.small',
                gap: 'spacing-6',
                _icon: {
                    width: '4',
                    height: '4'
                }
            }
        }
    },
    compoundVariants: [
        {
            variant: 'primary',
            underline: true,
            css: {
                borderBottomColor: 'border.brand'
            }
        },
        {
            variant: 'secondary',
            underline: true,
            css: {
                borderBottomColor: 'border.strong'
            }
        }
    ],
    defaultVariants: {
        variant: 'secondary',
        underline: false,
        size: 'default'
    }
})
